import { Helmet } from "react-helmet-async";
import { absoluteAssetUrl, canonicalUrl, DEFAULT_IMAGE, DEFAULT_IMAGE_ALT, SITE_NAME } from "./metadata";

export default function Seo({ metadata, structuredData }) {
	const { title, description, path, type = "website", noindex, publishedTime, modifiedTime, section } = metadata;
	const url = canonicalUrl(path);
	const image = absoluteAssetUrl(metadata.image || DEFAULT_IMAGE);
	const imageAlt = metadata.imageAlt || DEFAULT_IMAGE_ALT;
	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large"} />
			{!noindex && <link rel="canonical" href={url} />}
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:type" content={type} />
			<meta property="og:url" content={url} />
			<meta property="og:site_name" content={SITE_NAME} />
			<meta property="og:locale" content="en_US" />
			<meta property="og:image" content={image} />
			<meta property="og:image:alt" content={imageAlt} />
			<meta property="og:image:width" content={String(metadata.imageWidth || 1200)} />
			<meta property="og:image:height" content={String(metadata.imageHeight || 630)} />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={image} />
			<meta name="twitter:image:alt" content={imageAlt} />
			{publishedTime && <meta property="article:published_time" content={publishedTime} />}
			{modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
			{section && <meta property="article:section" content={section} />}
			{structuredData && <script type="application/ld+json">{JSON.stringify(structuredData).replace(/</g, "\\u003c")}</script>}
		</Helmet>
	);
}
